<template lang="pug">
	content-page
		div(slot="nav")
			navigation-default
		h1 {{contentpage.name}}
		ws-content(:value="contentpage.content")
		v-data-table(:headers="headers" :items="mapped_skipasses" sort-by="sixdays_euro" disable-pagination hide-default-footer)
			template(v-slot:item="{item}")
				tr
					td
						img.flag.mr-2(:src='`https://static.wintersport.nl/images/flags/svg/${item.item.countrycode}.svg`')
						nuxt-link(:to="item.to") {{item.item.name}}
					td
						span.bar.horizontal
							| {{ $n(item.sixdays_euro, 'currency', $i18n.locale) }}&nbsp;
							i(:style="`width:${(item.sixdays_euro/maxprice)*100}%;`") {{ $n(item.sixdays_euro, 'currency', $i18n.locale) }}&nbsp;
					td(align="right") {{item.item.totalkms}}km
					td(align="right") {{ $n(item.priceperkm, 'currency', $i18n.locale) }}


		.caption.grey--text {{$t('page.areas._area.skipas:price.per.cluster')}}
</template>

<script>
import gql from 'graphql-tag';
import MetaFragment from '@/components/graphql/metaFragment.graphql';
import Content from '@dengl/common/components/content.vue';
import SkipasPriceTable from '@/components/skipas-price-table.vue';
import NavigationDefault from '@/components/navigation-default';

const getAllSkipasses = gql`
	query getAllSkipasses($path: String!) {
		contentpage(path: $path) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
		skipasses {
			sixdays(convertToEuro: true)
			currency
			item {
				id
				name
				slug
				... on Cluster {
					totalkms
					areas {
						country {
							id
							countryCode
						}
					}
				}
				... on Area {
					slopeinfo {
						total
					}
					country {
						id
						countryCode
					}
				}
			}
		}
	}
	${Content.fragments}
	${MetaFragment}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/skigebieden/skipasprijzen',
			'de-DE': '/skigebiete/skipasspreise',
			'nl-BE': '/skigebieden/skipasprijzen'
		}
	},
	components: {
		SkipasPriceTable,
		NavigationDefault
	},
	layout: 'default',
	asyncData({ app, error, route }) {
		return app.$graphClient
			.query({
				query: getAllSkipasses,
				variables: {
					path: route.path
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}
				if (!data.contentpage) {
					return error({ statusCode: 404, message: 'Page not found' });
				}
				app.ads({ navigation: { visible: true, type: 'spot' } });

				app.meta(data.contentpage.meta);

				app.breadcrumbs({
					[app.i18n.t(`page.areas:heading`)]: {
						name: 'areas'
					},
					[app.i18n.t(`page.areas.skipasses:heading`)]: {
						name: 'areas-skipasses'
					}
				});

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'areas-skipasses-01', error);
			});
	},
	data() {
		return {
			pagination: {
				sortBy: 'sixdays_euro',
				rowsPerPage: -1
			},
			headers: [
				{ text: this.$t('skipas.heading.area'), value: 'item.slug' },
				{
					text: this.$t('skipas.heading.price.6.days'),
					value: 'sixdays_euro'
				},
				{
					text: this.$t('skipas.km.piste'),
					value: 'item.totalkms',
					align: 'right'
				},
				{
					text: this.$t('skipas.price.per.km'),
					value: 'priceperkm',
					align: 'right'
				}
			]
		};
	},
	computed: {
		maxprice() {
			return Math.max.apply(
				null,
				this.mapped_skipasses.map(skipas => skipas.sixdays_euro)
			);
		},

		mapped_skipasses() {
			return this.skipasses
				.map(skipas => {
					if (!skipas.item || !skipas.sixdays) {
						return false;
					}

					if (skipas.item.__typename === 'Area') {
						skipas.item.totalkms = skipas.item.slopeinfo.total;
						skipas.item.countrycode = skipas.item.country.countryCode;
						skipas.to = this.localePath({
							name: 'areas-area-skipas',
							params: { area: skipas.item.slug }
						});
					} else {
						skipas.to = this.localePath({
							name: 'clusters-cluster',
							params: { cluster: skipas.item.slug }
						});
						skipas.item.countrycode = skipas.item.areas[0].country.countryCode;
					}

					if (!skipas.item.totalkms) return false;

					skipas.sixdays_euro = skipas.sixdays;
					// skipas.sixdays_euro = this.$options.filters.currency(
					// 	skipas.sixdays,
					// 	skipas.currency,
					// 	{
					// 		returnvalue: true
					// 	}
					// );

					skipas.priceperkm = skipas.sixdays_euro / skipas.item.totalkms;

					return skipas;
				})
				.filter(e => !!e);
		}
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
